import { EXCHANGE } from './Onboarding';

export interface IWidgetStatus {
  status: string;
  data: IDataWidget;
}

export interface IDataWidget {
  companyId: string;
  user: User;
  person: Person;
  side?: string;
  asset?: string;
  against?: string;
  againstAmount?: string;
  withdrawAddress?: string;
  withdrawNetwork?: number;
  exchange?: EXCHANGE;
}

export interface Person {
  legalId: string;
  email: string;
  personalData: PersonalData;
  renaperData: RenaperData;
  flags: Flags;
}

export interface Flags {
  isPEP: boolean;
  isUIF: boolean;
  isDead?: boolean;
  isTerrorist?: boolean;
  isFATCA: boolean;
}

export interface PersonalData {
  name?: string;
  surname?: string;
  work?: string;
  birthDate?: Date;
  address?: Address;
  sex?: string;
  nationality?: string;
  maritalStatus?: string;
  phoneNumber?: string;
}

export interface Address {
  postalCode?: string;
  province?: string;
  street?: string;
  numeration?: number;
  floor?: string;
  apartment?: string;
  locality?: string;
}

export interface RenaperData {
  isDead: boolean;
  dniModel: string;
  dniNumber: string;
  name: string;
  surname: string;
}

export interface User {
  id: string;
  companyId: string;
  clientId: string;
  numberId: string;
  legalId: string;
  email: string;
  type: string;
  status: string;
  banking: Banking;
  onboarding: Onboarding;
}

export interface Banking {
  accounts: IBankAccount[];
}

export interface IBankAccount {
  cbu: string;
  currency: string;
  description: string;
}

export interface IFieldsPersonalData {
  personalData?: PersonalData;
  flags?: Flags;
}

export interface Onboarding {
  EMAIL_VALIDATION: OnboardingStep;
  IDENTITY_DECLARATION: OnboardingStep;
  BASIC_PERSONAL_DATA_DEFINITION: OnboardingStep;
  TYC_ACCEPTANCE: OnboardingStep;
  POLITICAL_CONSTRAINTS_VALIDATION: OnboardingStep;
  SECURITY_VALIDATION: OnboardingStep;
  BANK_ACCOUNT_DEFINITION: OnboardingStep;
  FEP_DOCUMENTATION_VALIDATION: OnboardingStep;
  PEP_DOCUMENTATION_VALIDATION: OnboardingStep;
  IDENTITY_VALIDATION: OnboardingStep;
  SELFIE_VALIDATION: OnboardingStep;
}

export interface OnboardingStep {
  required: boolean;
  status: Status;
}

export enum Status {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Failed = 'FAILED',
}

export enum STATUS_WIDGET_USER {
  ACTIVE = 'ACTIVE',
  EMAIL_VALIDATED = 'EMAIL_VALIDATED',
  PERSONAL_DATA_COMPLETE = 'PERSONAL_DATA_COMPLETE',
  USER_DATA_COMPLETE = 'USER_DATA_COMPLETE',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
}
